import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "windows",
  "use": "windows-usage",
  "viewBox": "0 0 18 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 20\" id=\"windows\"><path d=\"M8.028 2.034V8.58L18 8.218V0L8.028 2.034zM0 3.833v5.07l5.646-.208V2.68L0 3.833zm0 12.334l5.646 1.153v-6.016L0 11.097v5.07zm8.028 1.8L18 20v-8.218l-9.972-.362v6.546z\" fill=\"#1296DB\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id